import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { BomaidMainMenuComponent } from './bomaid-main-menu.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule
  ],
  declarations: [BomaidMainMenuComponent],
  exports: [BomaidMainMenuComponent],
})
export class BomaidMainMenuModule { }